<input nbInput
       i18n-placeholder="@@PromoCode"
       placeholder="Введите промокод"
       fieldSize="small"
       name="promoCode" [formControl]="promoCodeControl">

<button nbButton size="small" i18n="@@UsePromoCode" (click)="usePromoCode()">Применить</button>
